import React from 'react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
const path = ['7 days.', '15 minutes a day.', 'One clear path.', 'One structured protocol.'];
export function FinalCta() {
  return <section className="bg-brand-900 px-5 py-16 text-center sm:py-24" data-id="element-173" data-mp="1no6ookvjssvy">
      <div className="mx-auto max-w-3xl" data-id="element-174" data-mp="1snj96yyy5nvd">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-gold sm:text-sm" data-id="element-175" data-mp="1smhvsnugkpah">Ready to stop collecting techniques…</p>
        <h2 className="mt-4 font-display text-[32px] font-bold leading-tight text-white sm:text-5xl" data-id="element-176" data-mp="1eqnwmwjhleak">
          …and start <em className="text-brand-200" data-id="element-177" data-mp="14qdmxlwnup05">practicing Apometry?</em>
        </h2>
        <p className="mt-6 text-[17px] leading-relaxed text-brand-100" data-id="element-178" data-mp="14sgkcr057kew">
          You don’t need to learn everything today. You don’t need to study for months before you begin. Start with:
        </p>
        <ul className="mx-auto mt-6 grid max-w-md gap-2" data-id="element-179" data-mp="2z2bwjoyvtmwk">
          {path.map(p => <li key={p} className="rounded-xl bg-white/10 px-4 py-3 text-lg font-bold text-white" data-id="element-180" data-mp="341583bulz3u3">
              {p}
            </li>)}
        </ul>
        <p className="mt-8 font-display text-5xl font-extrabold text-white" data-id="element-181" data-mp="3ted33ehz4lw7">$27 USD</p>
        <CtaButton label="I want the 7D Apometry Protocol™" className="mt-6" data-id="element-182" data-mp="b1omicbq11yr" />
        <p className="mt-3 text-[13px] text-brand-200" data-id="element-183" data-mp="703f36hyhfvy">Instant download · Lifetime access · One-time payment · 7-day guarantee</p>
        <Countdown tone="dark" data-id="element-184" data-mp="3fgoebvksculv" />
      </div>
    </section>;
}